import script from "./GroupView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupView.vue?vue&type=script&lang=ts&setup=true"

import "./GroupView.vue?vue&type=style&index=0&id=e35690bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e35690bc"]])

export default __exports__